import { render, staticRenderFns } from "./otaband.vue?vue&type=template&id=a70c1a2a&scoped=true"
import script from "./otaband.vue?vue&type=script&lang=js"
export * from "./otaband.vue?vue&type=script&lang=js"
import style0 from "./otaband.vue?vue&type=style&index=0&id=a70c1a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70c1a2a",
  null
  
)

export default component.exports